/**
 * LeadEducationGuidePage — public bilingual patient education guide
 * (Luisa R1, Jun 11 2026).
 *
 * Lives OUTSIDE the auth shell (same pattern as the proposal + intake
 * pages): App.js renders it for /education before the auth check. It is
 * general, non-PHI educational content — no token, no login. The PEM
 * sends the link after a discovery call (R5 handoff).
 *
 * Bilingual EN/ES with a language toggle; defaults from ?lang=es. Content
 * is verbatim from src/lib/educationGuideContent.js (Luisa's vetted copy).
 */
import React, { useState } from 'react';
import { Globe, ShieldCheck } from 'lucide-react';
import { EDUCATION_GUIDE } from '../lib/educationGuideContent';
// Card P77 item 10: the sections are rendered by a shared component so the
// in-CRM staff view and this public page cannot drift apart.
import EducationGuideBody from '../components/EducationGuideBody';

function initialLang() {
  try {
    const p = new URLSearchParams(window.location.search);
    return p.get('lang') === 'es' ? 'es' : 'en';
  } catch (_) { return 'en'; }
}

export default function LeadEducationGuidePage() {
  const [lang, setLang] = useState(initialLang);
  // EDUCATION_GUIDE is still read here for the toggle's label; the sections
  // themselves are rendered by EducationGuideBody.
  const other = lang === 'en' ? 'es' : 'en';

  return (
    <div style={{ minHeight: '100vh', background: '#F3F4F6', padding: '2rem 1rem' }}>
      <div style={{
        maxWidth: 720, margin: '0 auto', background: '#fff',
        borderRadius: 16, padding: '2rem 2.25rem', boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      }}>
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, marginBottom: 20 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <ShieldCheck size={28} color="#2563eb" />
            <div>
              <div style={{ fontSize: '0.7rem', fontWeight: 700, color: '#2563eb', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                Zignagenix Regenerative Medicine
              </div>
            </div>
          </div>
          <button
            onClick={() => setLang(other)}
            style={{
              flexShrink: 0, display: 'inline-flex', alignItems: 'center', gap: 5,
              padding: '6px 12px', background: '#EFF6FF', border: '1px solid #BFDBFE',
              borderRadius: 999, color: '#1E40AF', fontSize: '0.8rem', fontWeight: 700, cursor: 'pointer',
            }}
            aria-label={`Switch to ${EDUCATION_GUIDE[other].langLabel}`}
          >
            <Globe size={13} /> {EDUCATION_GUIDE[other].langLabel}
          </button>
        </div>

        <EducationGuideBody lang={lang} />

      </div>
    </div>
  );
}
